export default __webpack_public_path__ + "static/media/Group1435.bb470523.svg";